import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cc449dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-hint" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "hint-down"
}

import { PropType } from 'vue'


enum Hint {
  DOWN = "down",
}

const __default__ = {}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  hint: {
    type: String as PropType<Hint>,
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "title")
        ]),
        (__props.hint === 'down')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_ui_icon, {
                class: "icon",
                name: "down"
              }),
              _createVNode(_component_ui_icon, {
                class: "icon",
                name: "down"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}
}

})